import React, { useEffect, useState } from "react";
import { getFlag } from "../utils/Utils";
import { Tooltip, Table, Empty, Button, message, Divider, Space, Modal } from "antd";
import moment from "moment-timezone";
import { DownloadOutlined } from '@ant-design/icons';
import { apiCall } from "../utils/Api";
import Session, { useSession } from "../utils/Session";
import Overlay from "../util_components/Overlay";
import BusinessContactInfo from "./BusinessContactInfo";


export const drawOO = (_code) => {
        let msg = ""
        switch (_code) {

            case "ITO":
                msg = <>Import To Order<small><br />Must be imported, taking at least 2-6 weeks to get stock.</small></>
                break;

            case "Qwk":
                msg = <>Quick<small><br />Not stocked, but can get stock in less than 2 weeks.</small></>
                break;

            case "LOW":
                msg = <>LOW<small><br />Stock onhand is relatively low. Item may get backordered/cancelled.</small></>
                break;

            case "POD":
                msg = <>Print On Demand<small><br />Copies printed on demand.</small></>
                break;

            case "QPOD":
                msg = <>Quick Print On Demand<small><br />Ships in 3-5 business days</small></>
                break;

            case "RP":
                msg = <>Reprinting<small><br />The book is being reprinted by the publisher.</small></>
                break;

            case "NYR":
                msg = <>Not Yet Received / Published<small><br />Not received by the wholesaler or published by the publisher.</small></>
                break;

            case "TOS":
                msg = <>Temporarily out of stock<small><br />Item will be in stock shortly.</small></>
                break;

            case "BOO":
                msg = <>Backorder Only<small><br />Title available as a special order. ETA unknown.</small></>
                break;

            case "Mgd":
                msg = <>Managed Title<small><br />Quantities shipped are managed manually.</small></>
                break;

        }
        return msg;
    }


    export const drawOOToolTip = (_str) => {

        let _arr = [
            "ITO - Import To Order: must be imported, taking at least 2-6 weeks to get stock.",
            "Qwk - Quick: not stocked, but can get stock in less than 2 weeks.",
            "POD - Print On Demand: copies printed on demand.",
            "QPOD - Ships in 3-5 business days",
            "RP - Reprinting: the book is being reprinted by the publisher.",
            "NYR - Not Yet Received/Published: not yet received by the wholesaler, or published by the publisher.",
            "TOS - Temporarily out of stock: item will be in stock shortly.",
            "BOO - 'Backorder Only' title available as special order. ETA unknown.",
            "Mgd - Managed title: quantities shipped are managed manually"
        ]

        return (
            <Tooltip overlayInnerStyle={{ width: "550px" }} title={<>
                <div>Non-numeric OO pubstock codes.</div>
                <div className="shim" />
                <div>
                    <small>
                        {_arr.map(item => {
                            return (<div>{item}</div>)
                        })}
                    </small>
                </div>
            </>}>
                <span style={{ "cursor": "pointer" }}>{_str}</span>
            </Tooltip>
        )
    }

export default function Pubstock(props) {

    const { eisbn = "" } = props;
    const [session, setSession] = useSession();
    const [suppliers, setSuppliers] = useState(props.suppliers);
    const [loaded, setLoaded] = useState((session.has_bm_data_lite || session.has_bm_data_full));
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setSuppliers(props.suppliers)
    }, [props.suppliers])

    
   


    const ColumnHelp = (props) => {

        return (
            <Tooltip title={<small>{props.title}</small>}>
                <span style={{ "cursor": "pointer" }} >{props.children}</span>
            </Tooltip>
        )
    }

    const drawOOMsg = (_code) => {

        let msg = drawOO(_code);

        if (msg) {
            return (<ColumnHelp title={msg}>{_code}</ColumnHelp>)
        }

        return _code;

    }



    const suppliers_columns = [
        {
            title: <div style={{ "textAlign": "left" }}><small>Suplr</small></div>, key: 'acct', dataIndex: 'acct', render: (e, f) => {
                return <div style={{ "textAlign": "left" }}><Space size={2}><nobr>{getFlag(f.country)}</nobr> &nbsp; <Overlay width={600} component={<div style={{ "padding": "20px" }}><strong>Contact</strong><Divider dashed style={{ "margin": "10px 0px" }} /><div className="shim" /><div style={{ "margin": "-8px" }}><BusinessContactInfo id={f.id} /></div></div>}><a style={{ "textAlign": "left", "maxWidth": "250px", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>{e}</a></Overlay></Space></div>

                return;
            }
        },
    ]


    suppliers_columns.push(
        {
            title: <small>O/H</small>, key: 'onhand', dataIndex: 'onhand', render: (e) => {

                return (e) ? <span style={{ "color": "#4F9818" }}>{e.toString()}</span> : ""

            }
        }
    )

    suppliers_columns.push(
        {
            title: <small>{drawOOToolTip("O/O")}</small>, key: 'onorder', dataIndex: 'onorder', render: (e) => {
                return (e) ? <span style={{ "color": "#E77E21" }}>{drawOOMsg(e)}</span> : ""
            }
        }
    )


    suppliers_columns.push({ title: <small><ColumnHelp title="Prices are in vender's currency" >Price</ColumnHelp> </small>, key: 'supplier_price', dataIndex: 'supplier_price' })
    if (session.logged_in) {
        suppliers_columns.push({ title: <small><ColumnHelp title="Discounts shown reflect general trade bookseller levels." >%</ColumnHelp> </small>, key: 'discount', dataIndex: 'discount' })
    }
    suppliers_columns.push({ title: <small><ColumnHelp title={<>Returnability codes:<br /> Y = returnable <br />N = non-returnable <br />C = may be returnable, but conditions are applied. Contact vendor for details.</>} >Rtrn</ColumnHelp></small>, key: 'returnable', dataIndex: 'returnable' })
    suppliers_columns.push({ title: <small>As of</small>, key: 'as_of', width: 80, dataIndex: 'as_of', render: (e) => { return (e) ? <nobr>{moment(e * 1000).fromNow()}</nobr> : "" } })




    const fetchPubstock = () => {
        setLoading(true)
        apiCall("title/getPubstock", { eisbn: eisbn }, (_s, _r) => {
            if (_s) {
                setLoaded(true);
                setSuppliers(_r);
            } else {

                if (_r.error === "too many requests" || _r.error === "Reached tracking limit") {
                    Modal.error({
                        title: "Too many requests",
                        content: <>
                            We are unable to fulfill your Pubstock request as you have reached the maximum number of lookups allowed for casual usage. Increased lookups require an annual subscription. <br /> <br />Please contact us at 250-763-4415 or <a href="mailto:mail@bookmanager.com">mail@bookmanager.com</a> for more information, or to create an account.
                        </>
                    })
                } else {
                    message.error(_r.error)
                }

            }
            setLoading(false)

        })
    }

    const customEmpty = (
        <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<Button type="primary" size="small" onClick={() => fetchPubstock()} ><small>Click to load Pubstock</small></Button>}
        />
    );



    return (
        <div>
            <div style={{ "fontSize": "13px", "fontWeight": "500" }}>Pubstock</div>
            <Table
                expandable
                size="small"
                loading={loading}
                pagination={false}
                columns={suppliers_columns}
                style={{ "width": "100%", "border": "1px solid #eee", "borderBottom": "0px" }}
                className={"mediumTable bc"}
                dataSource={suppliers}
                locale={{
                    emptyText: (loaded) ? null : customEmpty,
                }}
                rowKey={"acct"}
            />
        </div>
    )
}